<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid w-100" style="overflow: hidden">
      <navbar :title="$t('materialstorage.title_plural')"/>
      <div class="search-form px-3 my-2">
        <div class="col-sm-12 search-form-title">
          <font-awesome-icon icon="search" />
          {{ $t('common.search') }}
        </div>
        <form
          @submit.prevent="onSubmit"
          @reset.prevent="onReset"
        >
          <div class="row nopads">
            <div class="col-sm-6">
                <span class="span-title">{{ $t('materialstorage.name') }}</span>
                <input
                  id="storage_name"
                  v-model="storageName"
                  class="form-control form-control-sm"
                  type="text"
                />
            </div>

            <div class="col-sm-6">
                <span class="span-title">{{ $t('materialstorage.user') }}</span>
                <select
                    id="storageCreatedBy"
                    v-model="storageCreatedBy"
                    class="form-select form-select-sm"
                    :disabled="!users || !users.length"
                >
                    <option :value="null">
                        {{ $t('materialstorage.select_user') }}
                    </option>
                    <option
                        v-for="option in users"
                        :key="option.id"
                        :value="option.id"
                    >
                        {{ option.last_name + ', ' + option.first_name }}
                    </option>
                </select>
            </div>
          </div>
          <div class="row nopads">
              <div class="col-sm-6" style="padding-top: .4em">
                  <open-contract-filter
                      ref="contractFilter"
                      :from="now"
                      :show-company="false"
                      :row-view="true"
                      :show-only-my-contracts-option="true"
                      :show-title="true"
                      @loading="loading=true"
                      @loading-completed="loading=false"
                      @contract-selected="setContract"
                  />
              </div>
              <div class="col-sm-6">
                  <span class="span-title">{{ $t('relationships.main_contractor') }}</span>
                  <select
                      id="company"
                      v-model="company"
                      class="form-select form-select-sm"
                  >
                      <option :value="null">
                          {{ $t('orders.select_contractor') }}
                      </option>
                      <option
                          v-for="option in companyOptions"
                          :key="option.value"
                          :value="option.value"
                      >
                          {{ option.name }}
                      </option>
                  </select>
              </div>
          </div>
          <div class="row nopads">
              <div class="col-sm-6 ps-2 pe-1 pt-1">
                  <div class="form-group title">
                      <span class="span-title">{{ $t('companies.city') }}</span>
                      <select
                          id="citySelect"
                          class="form-select form-select-sm"
                          v-model="selectedCity"
                      >
                          <option v-for="city in cityOptions" :key="city.value" :value="city.value">
                              {{ city.text }}
                          </option>
                      </select>
                  </div>
              </div>
          </div>
          <div class="col-sm-12 button-container">
            <button
              type="submit"
              class="form-button btn btn-sm btn-primary"
            >
              {{ $t('common.search_verb') }}
            </button>
            <button
              type="reset"
              class="form-button btn btn-sm btn-danger"
            >
              {{ $t('common.clear') }}
            </button>
          </div>
        </form>
      </div>
    <!-- Buttons -->
        <div class="col-sm-12">
            <div
                v-if="results.length > 0"
                class="button-container col-sm-12 trip-buttons"
            >
                <button
                    :disabled="results.length < 1"
                    class="form-button btn btn-sm btn-outline-success"
                    @click="exportExcel"
                >
                    {{ $t('trip.download_excel') }}
                </button>

                <button
                    :disabled="loading"
                    class="btn btn-sm btn-primary form-button"
                    @click="toggleMapView"
                >
                    {{ toggleMapViewLabel }}
                </button>
            </div>
        </div>


    <!-- Map and results -->
    <div class="trip-results" v-show="results.length > 0">
        <div class="row">
            <!-- Sign list -->
            <div :class="{'col-md-6': mapVisible, 'col-12': !mapVisible}" class="mb-2">
                <Transition name="fade">
                    <material-storage-list
                        :storages="results"
                        ref="storageList"
                        @row-clicked="rowClicked"
                        @row-select="rowSelectionChanged"
                    />
                </Transition>
            </div>
            <div v-if="mapVisible" class="col-md-6 d-flex flex-column nopads pb-0 mb-2">
                <Transition name="fade">
                    <div class="flex-fill position-relative" style="border-radius: .75em; border: 1px solid #BCBCBC; overflow: hidden">
                        <div class="map-container mr-3 ml-3 mb-2" style="height: 35em; border-radius: .75em; border: 1px solid #BCBCBC; position: relative" >
                            <map-container
                                :find-user="false"
                                ref="mapContainer"
                                @on-marker-tap="onMarkerTap"
                                @on-map-changed="mapChanged"
                            />
                            <material-storage-map
                                ref="storageMap"
                                v-if="map"
                                :map="map"
                                :require-bounding-box="false"
                                :zoom-level-in-range="true"
                                :initial-storages="mapItems"/>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    </div>

    <material-storage-editor-modal
        :storage="editStorage"
        :user="user"
        @close="editStorage = null"
        @close-and-update="closeAndUpdate"
    />
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {mapHelper} from "@/components/mixins/MapMixin.js";
import MaterialStorageList from "./MaterialStorageList";
import MaterialStorageEditorModal from "./MaterialStorageEditorModal";
import Navbar from "@/components/utils/Navbar";
import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";
import Multiselect from "vue-multiselect";
import MapContainer from "../map/MapContainer.vue";
import MaterialStorageMap from "./MaterialStorageMap.vue";
import {downloadHelper} from "../mixins/DownloadMixin.js";

export default {
    name: 'MaterialStorageSearch',
    components: {
        MaterialStorageMap,
        MapContainer,
        Multiselect,
        OpenContractFilter,
        Navbar,
        MaterialStorageList,
        MaterialStorageEditorModal
    },
    mixins: [restApi, mapHelper, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: Boolean
    },
    data: function () {
        return {
            storageName: null,
            storageCreatedBy: null,
            loading: false,
            storages: [],
            users: [],
            results: [],
            editStorage: null,
            lastSearchedParams: null,
            contract: null,
            company: null,
            companyOptions: [],
            selectedCity: null,
            map: null,
            mapVisible: false,
            selectedIndex: null,
            selectedItems: [],
            toggleMapViewLabel: this.$t('trip.show_map'),
        }
    },
    computed: {
        now() {
            return new Date().toISOString();
        },
        mapItems() {
            if (this.selectedItems && this.selectedItems.length > 0){
                return this.selectedItems
            }
            return this.results
        }
    },
    mounted: function () {
        if (this.isObserver) {
            this.fetchUsers()
        }
        if (!this.isObserver && this.user) {
            this.users.push(this.user)
        }
        this.getContractCompanies()
    },
    methods: {
        fetchUsers: function () {
            this.loading = true
            this.restFetch(this.userUrl, this.handleUsers)
        },
        handleUsers: function (response) {
            this.users = response.data
            this.loading = false
        },
        searchStorages: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.restFetchParams(this.materialStorageUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        onSubmit: function () {
            let params = {}
            if (this.storageName) {
                params.name = this.storageName
            }
            if (this.storageCreatedBy) {
                params.modifiedBy = this.storageCreatedBy
            }
            if (this.contract) {
                params.contract = this.contract.id
            }
            if (this.company) {
                params.contractor = this.company
            }
            if (this.selectedCity) {
                params.city = this.selectedCity
            }
            this.$refs.storageMap?.initZoomToGroup()
            this.searchStorages(params)
        },
        setContract: function (contract) {
            this.contract = contract
            this.getContractCompanies()
        },
        getContractCompanies: function () {
            this.companyOptions = []
            this.loading = true
            this.restFetch(this.contractorUrl, this.handleContractCompanies)
        },
        handleContractCompanies: function (response) {
            if (response && response.data) {
                response.data.forEach(company => {
                    this.companyOptions.push({name: company.name, value: company.id})
                })
                this.companyOptions.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
            }
            this.loading = false
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        rowClicked: function (item) {
            this.editStorage = item
        },
        onReset: function () {
            this.storageName = null
            this.storageCreatedBy = null
            this.selectedCity = null
            this.company = null
            this.contract = null
        },
        closeAndUpdate: function () {
            this.editStorage = null
            this.searchStorages(this.lastSearchedParams)
        },
        toggleMapView: function () {
            this.mapVisible = !this.mapVisible
            if (!this.mapVisible) {
                this.map = null
            }
            this.toggleMapViewLabel = this.mapVisible ? this.$t('trip_list.hide_map') : this.$t('trip.show_map')
        },
        onMarkerTap: function (data) {
            this.selectedIndex = this.results.findIndex(item => item.id === data.id)
            this.$refs.storageList.setSelection(this.selectedIndex)
            this.$refs.storageList.scrollToSelected()
        },
        exportExcel: function () {
            this.loading = true
            let params = this.getCommonReportParams(this.lastSearchedParams)
            if (this.selectedItems.length > 0) {
                params.ids = this.selectedItems.map(item => item.id)
                params.city = null
            }
            this.restGetDownloadFile(this.materialStorageReportUrl, params, this.excelDownloadSuccess, this.fileDownloadFail)
        },

        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('materialstorage.report_file_name'))
        },

        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
        rowSelectionChanged(selection) {
            this.$refs.storageMap?.initZoomToGroup()
            this.selectedItems = selection
        },
        mapChanged(map) {
            this.map = map
        },

    }
}
</script>
